/**
 * URL publique de l’API : en prod Docker, `runtime-config.js` définit `window.__INVENTWEE_API_URL__`
 * à partir de la variable d’environnement du conteneur (`.env.prod`). Sinon build Vite (`VITE_API_URL`)
 * ou localhost en dev.
 */
export function getApiBaseUrl(): string {
  const w = typeof window !== 'undefined' ? window : undefined;
  const runtime = w && (w as Window & { __INVENTWEE_API_URL__?: string }).__INVENTWEE_API_URL__;
  const trimmed = runtime != null && String(runtime).trim() !== '' ? String(runtime).trim() : '';
  if (trimmed) {
    return trimmed.replace(/\/$/, '');
  }
  return (import.meta.env.VITE_API_URL || 'http://localhost:4001').replace(/\/$/, '');
}
